import React, { useState } from "react";
import { IonIcon, IonSkeletonText } from "@ionic/react";
import { star, chatbubble } from "ionicons/icons";
import { useGetUnreviewedOrdersId } from "../../providers/Orders";
import { useAuth } from "../../contexts/auth-context";
import { useHistory } from "react-router";

const UnreviewedOrdersBanner = () => {
  const history = useHistory();
  const { isUserAuthenticated } = useAuth();

  const { data: unreviewedOrderIds, isLoading: isUnreviewedIdsLoading } = useGetUnreviewedOrdersId({
    enabled: !!isUserAuthenticated,
    refetchOnMount: "always",
    refetchInterval: 60000, // 1 minute
  });

  const firstOrderId = unreviewedOrderIds?.[0];

  if (!isUserAuthenticated || !firstOrderId) {
    return null;
  }

  if (isUnreviewedIdsLoading) {
    return (
      <div className="mx-2.5 mb-3">
        <IonSkeletonText animated style={{ height: "74px", borderRadius: "16px", width: "100%" }} />
      </div>
    );
  }

  if (!unreviewedOrderIds || unreviewedOrderIds.length === 0) {
    return null;
  }

  const unreviewedCount = unreviewedOrderIds.length;

  const handleOpenOrderDetail = () => {
    history.push(`/my-order-detail/${firstOrderId}`);
  };

  return (
    <div className="flex items-center justify-between p-3 bg-[#F0F9FF] border border-[#BAE6FD] rounded-2xl mx-2.5 mb-3 relative overflow-visible shadow-sm">
      <div className="flex items-center gap-3">
        <IonIcon icon={star} className="text-[#0EA5E9] text-[32px]" />
        <div className="flex flex-col">
          <span className="font-bold text-[#1F1F1F] text-sm">
            Оцените{" "}
            <span
              onClick={handleOpenOrderDetail}
              className="hover:opacity-80 underline underline-offset-2 font-bold cursor-pointer"
            >
              заказ №{firstOrderId}
            </span>
          </span>
          <span className="text-[#8C8C8C] text-xs">Помогите нам стать лучше</span>
        </div>
      </div>

      <div className="relative">
        <button
          onClick={handleOpenOrderDetail}
          className="bg-[#0EA5E9] hover:bg-[#0284C7] active:bg-[#0369A1] transition-colors px-4 py-2 rounded-[20px] flex items-center gap-2 font-bold text-sm text-white"
        >
          <span>Оценить</span>
          <IonIcon icon={chatbubble} className="text-lg" />
        </button>
        {unreviewedCount > 1 && (
          <div className="absolute -top-1.5 -right-1.5 bg-[#0EA5E9] text-white text-[10px] font-bold w-5 h-5 flex items-center justify-center rounded-full border-2 border-white z-10">
            {unreviewedCount}
          </div>
        )}
      </div>
    </div>
  );
};

export default UnreviewedOrdersBanner;
